import styled from 'styled-components';

export const MapWrapper = styled.div<{ hide?: boolean }>`
  background: ${Styles.color.white};
  display: ${p => (p.hide ? 'none' : 'flex')};
  flex: 1 1 0;
  justify-content: center;
  position: relative;
  order: 1;

  ${Styles.desktop} {
    height: 100%;
    order: 2;
  }
`;
